import { useEffect } from "react";

interface FreestarAdSlotProps {
  placementName: string;
  slotId: string;
  adSize: string;
  className?: string;
}

const FreestarAdSlot = ({ placementName, slotId, adSize, className }: FreestarAdSlotProps) => {
  useEffect(() => {
    const w = window as any;
    w.freestar = w.freestar || {};
    w.freestar.queue = w.freestar.queue || [];
    w.freestar.queue.push(() => {
      w.freestar.newAdSlots([{ placementName, slotId }]);
    });
    return () => {
      w.freestar?.queue?.push(() => {
        w.freestar.deleteAdSlots(slotId);
      });
    };
  }, [placementName, slotId]);

  return <div className={className} data-freestar-ad={adSize} id={slotId} />;
};

export default FreestarAdSlot;
